<template lang="html">
	<div class="">
		<div v-if="errorShow">
			<HeadModule :openTarget="'post/detail?id=' + tid"/>
			<div class="content">
				<!-- 帖子内容 -->
				<div class="invitation_content">
					<div class="invitation_title">
						<p v-show="invitation.original_type == 1">原创</p>
						<span>{{invitation.subject}}</span>
					</div>
					<div class="likeNum">
						<p class="commentNum">{{ invitation.replies }} <span class="likeText">评论</span></p>
						<span>· </span>
						<p class="collectNum">{{ invitation.favtimes }} <span class="likeText">收藏 </span></p>
						<span>· </span>
						<p class="upvoteNum">{{ invitation.recommend_add }} <span class="likeText">点赞</span></p>
					</div>
					<div class="invitation_head">
						<div class="invitation_head_left">
							<img class="invitation_head_img" :src="invitation.pic" alt="">
							<div class="">
								<div class="author_name">
									<p class="userName">{{invitation.author}}</p>
									<p class="invitation_lv"><img src="../assets/image/Lv.png">{{invitation.level_name}}</p>
								</div>
								<p class="issue_time">{{this.timestampToTime(2, invitation.dateline*1000)}}</p>
							</div>
						</div>
						<div class="attention_button">
							＋关注
							<WxOpenTag :extinfo="'post/detail?id=' + tid"/>
						</div>
					</div>
					<div class="article" v-bind:class="{'showAll':show}">
						<div class="articleCon" ref="getheight" v-html="invitation_content"></div>
					</div>
					<div class="read_the_full_article_btn" v-show="article_btn" @click="show_all_txt_btn()">
						<span>阅读全文</span>
						<img src="../assets/image/all_txt.png" alt="">
					</div>

					<!-- 所属模块 -->
					<div class="belong_to_module">
						<div class="belong_to_moduleChild">
							<img class="module_logo" :src="invitation_mod.pic" alt="">
							<div class="">
								<p class="module_name">{{invitation_mod.name}}</p>
								<p class="module_description">{{invitation_mod.description}}</p>
							</div>
						</div>

						<p class="more_btn">
							<img src="../assets/image/more.png" alt="">
						</p>
						
						<WxOpenTag :extinfo="'forum/detail?id=' + invitation_mod.fid"/>
					</div>

					<div class="attention" v-show="invitation.original_type == 1">
						「本文为作者原创文章，未经授权禁止转载」
					</div>
				</div>

				<!-- 今日热榜 -->
				<div class="hot_content">
					<h3>今日热榜</h3>
					<div class="hot_content_">
						<div class="hot_content_con">
							<div class="microVideo_mod" v-for="(aa, index) in hot" :key="index">
								<div class="" v-if="index == 0">
									<img src="../assets/image/huo_1.png" alt="">
								</div>
								<div class="" v-if="index == 1">
									<img src="../assets/image/huo_2.png" alt="">
								</div>
								<div class="" v-if="index == 2">
									<img src="../assets/image/huo_3.png" alt="">
								</div>
								<div class="" v-if="index == 3">
									<img src="../assets/image/huo_4.png" alt="">
								</div>
								<div class="" v-if="index == 4">
									<img src="../assets/image/huo_4.png" alt="">
								</div>
								<div class="microVideo_mod_">
									{{aa.title}}
									<WxOpenTag :extinfo="'post/detail?id=' + aa.topicid" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="open_APP_btn">
					打开APP查看更多
					<WxOpenTag :extinfo="'post/detail?id=' + tid"/>
				</div> -->

				<!-- 相关阅读 -->
				<div class="correlation_content">
					<h3>相关阅读</h3>
					<div class="module_content" v-for="(bb, index) in correlation.slice(0, 2)" :key="index">
						<div class="module">
							<img :src="bb.pic" alt="" class="">
							<div class="module_con">
								<p class="module_title">{{bb.title}}</p>
								<div class="module_teacher">
									<div class="module_teacher_header">
										<img :src="bb.avatar" alt="">
										<span>{{bb.author}}</span>
									</div>
									<p>{{ bb.views }}人浏览</p>
								</div>
							</div>
						</div>
						<WxOpenTag :extinfo="'post/detail?id=' + bb.topicid"/>
					</div>
				</div>
				<!-- <div class="open_APP_btn">
					打开APP查看更多
					<WxOpenTag :extinfo="'post/detail?id=' + tid"/>
				</div> -->

				<!-- 直播课程 -->
				<div class="live_streaming_content">
					<h3>直播课程</h3>
					<div class="module_content" v-for="(b, index) in live_streaming.slice(0, 2)" :key="index">
						<div class="module">
							<img :src="b.pic" alt="">
							<div class="module_con">
								<p class="module_title">{{b.title}}</p>
								<div class="module_teacher">
									<div class="module_teacher_header">
										<img :src="b.avatar" alt="">
										<span>{{b.username}}</span>
									</div>
									<p>{{ b.hitnum }}人浏览</p>
								</div>
							</div>
						</div>
						<WxOpenTag :extinfo="'class/detail?id=' + b.id"/>
					</div>
				</div>

				<!-- 精华推荐 -->
				<div class="digest_content">
					<h3>精华推荐</h3>
					<div class="module_content" v-for="(a, index) in digest" :key="index">
						<div class="module">
							<img :src="a.avatar" alt="">
							<div class="module_con">
								<p class="module_title">{{a.title}}</p>
								<div class="module_teacher">
									<div class="module_teacher_header">
										<img :src="a.avatar" alt="">
										<span>{{a.author}}</span>
									</div>
									<p>{{ a.views }}人浏览</p>
								</div>
							</div>
						</div>
						<WxOpenTag :extinfo="'post/detail?id=' + a.topicid"/>
					</div>
				</div>

				<!-- 短视屏 -->
				<div class="micro_video_content">
					<h3>短视频</h3>
					<div class="module_content" v-for="(m, index) in microVideo" :key="index">
						<div class="module">
							<img :src="m.pic" alt="">
							<div class="module_con">
								<p class="module_title">{{m.title}}</p>
								<div class="module_teacher">
									<div class="module_teacher_header">
										<img :src="m.avatar" alt="">
										<span>{{m.username}}</span>
									</div>
									<p>{{ m.likenum }}人浏览</p>
								</div>
							</div>
						</div>
						<WxOpenTag :extinfo="'openclass/detail?id=' + m.courseid"/>
					</div>
				</div>
				<!-- <div class="open_APP_btn">
					打开APP查看更多
					<WxOpenTag :extinfo="'post/detail?id=' + tid"/>
				</div> -->

				<!-- 全部评论   -->
				<div class="comment_content" v-show="invitation.replies > 0">
					<div class="comment_headline">
						<h3>全部评论</h3>
						<p class="comment_num">({{invitation.replies}} 条)</p>
					</div>
					<div class="comment_comment_mod" v-for="(a, index) in connmetData" :key="index">
						<div class="comment_comment">
							<div class="comment_head_left">
								<img :src="a.pic" alt="" class="comment_head_img">
								<p>{{a.author}}</p>
							</div>
							<div class="comment_likenum">
								<img src="../assets/image/support64.png" alt="">
								<p>{{a.support_num}}</p>
							</div>
						</div>
						<div class="comment_comment_con">
							<div>
								<p class="comment_comment_con_txt" v-html="bbc2html(a.message)"></p>
							</div>
						</div>
					</div>
					<WxOpenTag :extinfo="'post/detail?locateCom=1&id=' + tid"/>
				</div>
				<!-- <div class="open_APP_btn">
					打开APP查看更多
					<WxOpenTag :extinfo="'post/detail?id=' + tid"/>
				</div> -->
			</div>

			<div class="callAppIcon" v-show="callApp">
				<img src="../assets/image/icon/ic_button.png" alt="">
				<WxOpenTag ref="wxopentag" :extinfo="'post/detail?id=' + tid" />
			</div>
			
			<div class="topIcon" v-show="topPost">
				<img src="../assets/image/icon/ic_top.png" alt="" @click="getTopBtn">
			</div>
		</div>
		
		<ErrorPage v-else/>
	</div>
</template>

<script>
	import {pagehost} from '@/utils/http.js';
	import WxShare from '@/utils/wxshare'
	import HeadModule from '@/components/HeadModule'
	import WxOpenTag from '@/components/WxOpenTag'
	import {bbc2html} from '@/utils/bbcode'
	import ErrorPage from '@/components/ErrorPage'
	
	export default {
		components: {
			HeadModule: HeadModule,
			WxOpenTag: WxOpenTag,
			ErrorPage: ErrorPage,
		},
		data() {
			return {
				tid: this.$route.query.tid || '',
				invitation: [],
				invitation_content: '',
				// 资讯
				information: [],

				show: false,
				article_btn: true,
				// 热榜
				hot: [],
				// 相关
				correlation: [],

				invitation_mod: [],
				else_uesr_comment: [],

				microVideo: [],
				// 精华
				digest: [],
				// 直播
				live_streaming: [],

				connmetData: [],

				jumpTarget: '',
				callApp: false,
				topPost: false,
				errorShow: true,
			}
		},

		created() {
			this.init();
		},

		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			window.addEventListener('scroll', this.getTopPost)
		},

		methods: {
			init() {
				this.getWx = new WxShare();
				this.getCon();
			},
			bbc2html: bbc2html,

			// 时间戳转化
			timestampToTime(type, cjsj) {
				var date = new Date(cjsj) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				if (type == 1) {
					var M_ = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
					var D_ = date.getDate() + '日'
					return M_ + D_
				} else {
					var Y = date.getFullYear() + '-'
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
					var D = date.getDate() + ' '
					var h = date.getHours() + ':'
					var m = date.getMinutes() + ':'
					var s = date.getSeconds()
					return Y + M + D + h + m + s
				}
			},
			// 获取帖子详情信息
			getCon() {
				this.$http({
					url: '/Post/details_new',
					method: 'get',
					params: {
						topicid: this.$route.query.tid,
						start: 0,
						limit: 5,
						sort: 0,
					},
				}).then((res) => {
					if (res.code == 0) {
						this.invitation = res.data[0];
						this.invitation_content = bbc2html(res.data[0].message);
						this.invitation_mod = res.data[0].forum_info
						this.txt_height();

						// 热门
						this._hot(res.data[0].forum_info.fid);
						// 相关内容
						this._correlation(res.data[0].forum_info.fid);
						// 精华推荐
						this._digest(res.data[0].forum_info.fid);
						// 直播
						this._live_streaming();
						// 短视屏
						this.micro_video();
						this.connmetData = res.data.splice(1, 4);

						/* 微信分享 */
						this.getWx.share({
							title: res.data[0].subject,
							desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
							link: window.location.href,
							imgUrl: pagehost + '/images/common/logo.jpeg',
						});
					}

					if (res.code == '-700') {
						this.errorShow = false;
					}
				})
			},

			// 判断文章显示高度
			txt_height() {
				this.$nextTick(function() {
					let height = this.$refs.getheight.offsetHeight;
					if (height > 478) {
						this.show = false;
						this.article_btn = true;
					} else {
						this.show = true;
						this.article_btn = false;
					}
				})
			},
			// 阅读全文按钮
			show_all_txt_btn() {
				this.show = true;
				this.article_btn = false;
			},

			// 热门
			_hot(hot) {
				this.$http({
					url: '/Discuss/getThemeInForum',
					method: 'get',
					params: {
						forumid: hot,
						start: 0,
						limit: 5,
						order: 'hot',
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.hot = res.data;
					}
				})
			},
			// 相关阅读
			_correlation(cor) {
				this.$http({
					url: '/Discuss/getThemeInForum',
					method: 'get',
					params: {
						forumid: cor,
						start: 0,
						limit: 5,
						order: 'lastpost',
					},
				}).then((res) => {
					if (res.code == 0) {
						this.correlation = res.data;
					}
				})
			},
			// 直播课程
			_live_streaming() {
				this.$http({
					url: '/edu/listCourse',
					method: 'get',
					params: {
						type: '3',
					},
				}).then((res) => {
					if (res.code == 0) {
						this.live_streaming = res.data;
					}
				})
			},
			// 精华推荐
			_digest(dig) {
				this.$http({
					url: '/Discuss/getThemeInForum',
					method: 'get',
					params: {
						forumid: dig,
						start: 0,
						limit: 2,
						order: 'digest',
					},
				}).then((res) => {
					if (res.code == 0) {
						this.digest = res.data;
					}
				})
			},
			// 巢影短视屏
			micro_video() {
				this.$http({
					url: '/edu/weishi',
					method: 'get',
					params: {
						page: 1,
						limit: 2,
					},
				}).then((res) => {
					if (res.code == 0) {
						this.microVideo = res.data;
					}
				})
			},

			getTopBtn() {
				window.scroll(0, 0);
			},

			// 监听打开app按钮显示隐藏
			handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 56) {
          this.callApp = true;
        } else {
          this.callApp = false;
        }
      },

			getTopPost() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 56) {
          this.topPost = true;
        } else {
          this.topPost = false;
        }
      },
		},
	}
</script>

<style lang="css" scoped>
	.content {
		box-sizing: border-box;
		background: #F7F8F8;
	}

	.invitation_content {
		padding: 0 15px;
		padding-bottom: 1rem;
		background-color: #fff;
	}

	.invitation_title {
		margin-top: 17px;
		font-size: 18px;
		color: #1D2023;
		font-weight: 600;
	}

	.invitation_title p {
		position: relative;
		top: -.2rem;
		box-sizing: border-box;
		background-color: #FFDAD8;
		color: #F7443F;
		display: inline;
		font-size: 1.1rem;
		padding: .25rem .5rem;
		margin-right: .5rem;
		border-radius: .2rem;
	}

	.invitation_head {
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.invitation_head_left {
		display: flex;
		align-items: center;
	}

	.invitation_head_img {
		width: 40px;
		height: 40px;
		object-fit: cover;
		border-radius: 20px;
		border: .05rem solid #E5E6EB;
	}

	.author_name {
		display: flex;
		color: #3F454B;
		font-size: 14px;
		margin-left: 8px;
	}

	.userName {
		font-weight: 600;
	}

	.invitation_lv {
		margin-left: 5px;
		padding: 0 3px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 9px;
		color: #2086FC;
		background-color: #E2EFFE;
		border-radius: 2px;
	}

	.invitation_lv img {
		margin-right: 2px;
		margin-top: 1px;
		width: 12px;
		height: 12px;
	}

	.issue_time {
		color: #606972;
		font-size: 10px;
		margin-left: 8px;
		margin-top: 4px;
	}

	.attention_button {
		position: relative;
		width: 62px;
		height: 24px;
		line-height: 24px;
		border-radius: 12px;
		text-align: center;
		background-color: red;
		color: #fff;
		font-size: 14px;
	}

	.article {
		padding-top: 1.5rem;
		height: 478px;
		overflow: hidden;
	}

	.showAll {
		height: 100%;
		overflow: inherit;
	}

	.articleCon >>> img {
		width: 100%;
	}

	.read_the_full_article_btn {
		width: 100%;
		height: 40px;
		background-color: red;
		background: linear-gradient(#ffffff, #f2f2f2);
		line-height: 40px;
		text-align: center;
		color: #F5A623;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.read_the_full_article_btn img {
		width: 18px;
		height: 18px;
	}

	/* 所属模块 */
	.belong_to_module {
		position: relative;
		box-sizing: border-box;
		margin-top: 20px;
		height: 80px;
		background-color: #FEF6E9;
		border-radius: 5px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.belong_to_moduleChild {
		display: flex;
		align-items: center;
	}

	.module_logo {
		width: 54px;
		height: 54px;
		margin-left: 15px;
		margin-right: 10px;
		flex-shrink: 0;
	}

	.module_name {
		color: #000000;
		font-size: 16px;
		font-weight: 600;
	}

	.module_description {
		color: #606972;
		font-size: 14px;
		overflow: hidden;
		-webkit-line-clamp: 1;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	.more_btn {
		margin-left: 19px;
		margin-right: 15px;
	}

	.more_btn img {
		width: 20px;
	}

	.attention {
		font-size: 1.3rem;
		color: #F7443F;
		margin-top: 1.5rem;
		text-align: center;
	}

	/* 今日热榜 */
	.hot_content {
		padding: 15px;
		margin-top: 10px;
		background-color: #fff;
	}

	.hot_content_ {
		display: flex;
		width: 100%;
	}

	.hot_content_con {
		width: 100%;
	}

	.microVideo_mod {
		width: 100%;
		height: 45px;
		line-height: 45px;
		display: flex;
	}

	.microVideo_mod img {
		width: 18px;
		height: 18px;
		margin-right: 10px;
		margin-top: 13px;
	}

	.microVideo_mod_ {
		position: relative;
		width: 100%;
		overflow: hidden;
		-webkit-line-clamp: 1;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	/* 相关阅读 */
	.correlation_content {
		padding: 15px;
		background-color: #fff;
		margin-top: 1rem;
	}

	.module_content{
		position: relative;
		border-bottom: .05rem solid rgba(0, 0, 0, 0.1);
	}

	.module {
		box-sizing: border-box;
		padding: 1.2rem 0;
		display: flex;
		justify-content: space-between;
		font-size: 1.2rem;
		color: #606972;
	}

	.module_content:nth-last-child(1) {
		border-bottom: none;
	}

	.module img {
		width: 11.2rem;
		height: 80px;
		border-radius: 5px;
		object-fit: cover;
		border: .05rem solid #E5E6EB;
	}

	.module_con {
		width: 21.8rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.module_title {
		color: #1D2023;
		font-size: 16px;
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	.module_teacher {
		display: flex;
		justify-content: space-between;
		font-size: 12px;
	}

	.module_teacher_header {
		display: flex;
		align-items: center;
	}

	.module_teacher_header img {
		width: 1.95rem;
		height: 1.95rem;
		border-radius: 50%;
		object-fit: cover;
		margin-right: .5rem;
		border: .05rem solid #E5E6EB;
	}

	.clod_app_btn {
		color: #2086FC;
		font-size: 12px;
	}

	.clodVertical {
		padding: 0 .5rem;
	}

	.teacher_name {
		color: #606972;
		font-size: 12px;
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	/* 相关阅读 */
	.live_streaming_content {
		padding: 15px;
		background-color: #fff;
		margin-top: 1rem;
	}

	/* 精华推荐 */
	.digest_content {
		padding: 15px;
		margin-top: 10px;
		background-color: #fff;
	}

	/* 巢影短视屏 */
	.micro_video_content {
		padding: 15px;
		margin-top: 10px;
		background-color: #fff;
	}

	/* 评论模块 */
	.comment_content {
		position: relative;
		padding: 15px;
		margin-top: 10px;
		background-color: #fff;
	}

	.comment_headline {
		display: flex;
		align-items: flex-end;
	}

	.comment_num {
		margin-left: 5px;
		padding-bottom: .38rem;
		font-size: 11px;
		color: #606972;
	}

	.comment_comment_mod {
		box-sizing: border-box;
		padding: 15px 0;
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
	}

	.comment_comment_mod:nth-last-child(2) {
		border-bottom: none;
	}

	.comment_comment {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}



	.comment_head_left {
		display: flex;
		align-items: center;
	}

	.comment_head_img {
		width: 35px;
		height: 35px;
		object-fit: cover;
		border-radius: 50%;
		margin-right: 11px;
		border: .05rem solid #E5E6EB;
	}

	.comment_likenum {
		display: flex;
		font-size: 10px;
		color: #999999
	}

	.comment_likenum img {
		width: 16px;
		height: 16px;
		margin-right: 3px;
	}

	.comment_likenum p {
		margin-top: -5px;
	}

	.comment_comment_con {
		box-sizing: border-box;
		margin-left: 45px;
		margin-top: 5px;
	}

	.comment_comment_con_txt {
		font-size: 14px;
	}

	/* 下载按钮 */
	.open_APP_btn {
		position: relative;
		margin: 10px 15px;
		border-radius: 3px;
		height: 35px;
		line-height: 35px;
		background-color: #E50120;
		text-align: center;
		color: #FCFCFC;
		font-size: 16px;
	}
	
	.likeNum {
		display: flex;
    align-items: center;
    margin-top: 1rem;
		color: #555555;
		font-size: 1.2rem;
	}

	.commentNum,
  .collectNum,
	.upvoteNum {
    font-size: 1.2rem;
    color: #555555;
    margin-left: .5rem;
  }

	.likeText {
    margin-right: .5rem;
  }

	.topIcon {
		position: fixed;
		right: 1.1rem;
		bottom: 3rem;
		z-index: 11;
	}

	.topIcon img {
    width: auto;
    height: 4.15rem;
  }

	.callAppIcon {
    position: fixed;
    right: 0;
    bottom: 10.6rem;
    z-index: 10;
  }

  .callAppIcon img {
    width: 11.1rem;
    height: 3.35rem;
  }
</style>
